<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>资产订单</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="_goBack">
              <i class="el-icon-close"></i> 返回
            </el-button>
          </div>
          <el-row :gutter="20" class="text-left">
            <el-col :span="6">
              <div class="form-item">
                <label class="form-label">选择仓库：</label>
                <span>{{assetInventoryEditInfo.shName}}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="form-item">
                <label class="form-label">盘点日期：</label>
                <span>{{assetInventoryEditInfo.invTime}}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="form-item">
                <label class="form-label">盘点说明：</label>
                <span>{{assetInventoryEditInfo.remark}}</span>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>盘点商品</span>
            <div>
              <el-button type="primary" size="small" @click="_openChooseProductModal">
                <i class="el-icon-plus"></i>选择商品
              </el-button>
            </div>
          </div>
          <el-table
            :data="assetInventoryEditInfo.inoutOrderProducts"
            border
            style="width: 100%">
            <el-table-column prop="productId" label="编号" align="center"></el-table-column>
            <el-table-column prop="prodName" label="名称" align="center"></el-table-column>
            <el-table-column prop="specName" label="规格" align="center"></el-table-column>
            <el-table-column prop="price" label="单价" align="center"></el-table-column>
            <el-table-column prop="quantity" label="账面数量" align="center"></el-table-column>
            <el-table-column label="盘点数量" align="center">
              <template slot-scope="scope">
                <el-input 
                  v-model="scope.row.invQuantity" 
                  type="number"
                  @blur="_computeData(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="将过期" align="center">
              <template slot-scope="scope">
                <el-input 
                  v-model="scope.row.willExpire" 
                  type="number"
                  @blur="_computeData(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="耗损" align="center">
              <template slot-scope="scope">
                <el-input 
                  v-model="scope.row.attrition" 
                  type="number"
                  @blur="_computeData(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="invProfit" label="盘盈" align="center"></el-table-column>
            <el-table-column prop="invLoss" label="盘亏" align="center"></el-table-column>
            <el-table-column prop="invProfitMoney" label="盘盈金额" align="center"></el-table-column>
            <el-table-column prop="invLossMoney" label="盘亏金额" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="small"
                  @click="_deleteProduct(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <div style="text-align: right; margin-top: 20px;">
          <el-button 
            type="warning" 
            style="margin-right: 20px;"
            @click="_goBack">
            <i class="el-icon-close"></i>取消
          </el-button>
          <el-button 
            type="primary" 
            @click="_doAssetInventory">
            <i class="el-icon-check"></i>提交
          </el-button>
        </div>
      </el-col>
    </el-row>

    <choose-product-and-spec ref="chooseProductAndSpec" @chooseProductAndSpec="handleChooseProduct"></choose-product-and-spec>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { updateAssetInventory, queryAssetInventory, queryAssetInventoryProduct } from '@/api/goods/assetInventoryApi'
import ChooseProductAndSpec from '@/components/goods/chooseProductAndSpec'

export default {
  components: {
    ChooseProductAndSpec
  },
  data() {
    return {
      assetInventoryEditInfo: {
        aiId: '',
        shId: '',
        shName: '',
        invTime: '',
        shopHouses: [],
        inoutOrderProducts: [],
        remark: '',
        shopId: getShopId()
      }
    }
  },
  created() {
    this.assetInventoryEditInfo.aiId = this.$route.query.aiId
    if (!this.assetInventoryEditInfo.aiId) {
      this.$message.error('非法操作')
      this.$router.go(-1)
      return
    }
    this.assetInventoryEditInfo.shopId = getShopId()
    this._queryAssetInventory()
    this.queryAssetInventoryProduct()
  },
  methods: {
    async _doAssetInventory() {
      const _inoutOrderProducts = this.assetInventoryEditInfo.inoutOrderProducts
      if (_inoutOrderProducts.length < 1) {
        this.$message.warning('请选择商品')
        return
      }
      
      // 处理商品数据，确保必需字段存在
      _inoutOrderProducts.forEach(item => {
        item.invQuantity = item.invQuantity || 0
        item.willExpire = item.willExpire || 0
        item.attrition = item.attrition || 0
        item.invProfit = item.invProfit || 0
        item.invLoss = item.invLoss || 0
        item.invProfitMoney = item.invProfitMoney || 0
        item.invLossMoney = item.invLossMoney || 0
      })
      
      try {
        const res = await updateAssetInventory(this.assetInventoryEditInfo)
        if (res.code === 0) {
          this.$message.success(res.msg || '更新成功')
          this._goBack()
        } else {
          this.$message.error(res.msg || '更新失败')
        }
      } catch (error) {
        console.error('更新资产盘点失败:', error)
        this.$message.error(error.message || error || '更新失败')
      }
    },
    handleChooseProduct(products) {
      // products 是一个数组
      if (products && products.length > 0) {
        products.forEach(product => {
          product.invProfit = 0
          product.invLoss = 0
          product.invProfitMoney = 0
          product.invLossMoney = 0
          product.invQuantity = 0
          product.willExpire = 0
          product.attrition = 0
          if (product.defaultSpecValue) {
            product.quantity = product.defaultSpecValue.stock
            product.specName = product.defaultSpecValue.specName
            product.valueId = product.defaultSpecValue.valueId
            product.price = product.defaultSpecValue.price
          }
          this.assetInventoryEditInfo.inoutOrderProducts.push(product)
        })
      }
    },
    _openChooseProductModal() {
      if (!this.assetInventoryEditInfo.shId) {
        this.$message.warning('请先选择仓库')
        return
      }
      this.$refs.chooseProductAndSpec.open({
        shId: this.assetInventoryEditInfo.shId
      })
    },
    _goBack() {
      this.$router.go(-1)
    },
    _deleteProduct(_inoutOrderProduct) {
      let index = this.assetInventoryEditInfo.inoutOrderProducts.indexOf(_inoutOrderProduct)
      if (index > -1) {
        this.assetInventoryEditInfo.inoutOrderProducts.splice(index, 1)
      }
    },
    async _queryAssetInventory() {
      try {
        const res = await queryAssetInventory({
          page: 1,
          row: 1,
          aiId: this.assetInventoryEditInfo.aiId,
          shopId: this.assetInventoryEditInfo.shopId
        })
        if (res.data && res.data.length > 0) {
          Object.assign(this.assetInventoryEditInfo, res.data[0])
        } else {
          console.warn('未找到资产盘点详情')
          this.$message.warning('未找到资产盘点详情')
        }
      } catch (error) {
        console.error('请求资产盘点详情失败:', error)
        this.$message.error('加载资产盘点详情失败')
      }
    },
    async queryAssetInventoryProduct() {
      try {
        const res = await queryAssetInventoryProduct({
          page: 1,
          row: 100,
          aiId: this.assetInventoryEditInfo.aiId,
          shopId: this.assetInventoryEditInfo.shopId
        })
        this.assetInventoryEditInfo.inoutOrderProducts = res.data || []
        // 为每个商品计算盘盈盘亏
        this.assetInventoryEditInfo.inoutOrderProducts.forEach(item => {
          this._computeData(item)
        })
      } catch (error) {
        console.error('请求商品列表失败:', error)
        this.$message.error('加载商品信息失败')
      }
    },
    _computeData(_inoutOrderProduct) {
      const invQuantity = parseInt(_inoutOrderProduct.invQuantity || 0)
      const quantity = parseInt(_inoutOrderProduct.quantity || 0)
      const price = parseFloat(_inoutOrderProduct.price || 0)
      
      _inoutOrderProduct.invProfit = invQuantity - quantity
      if (_inoutOrderProduct.invProfit < 0) {
        _inoutOrderProduct.invProfit = 0
      }
      _inoutOrderProduct.invLoss = quantity - invQuantity
      if (_inoutOrderProduct.invLoss < 0) {
        _inoutOrderProduct.invLoss = 0
      }
      _inoutOrderProduct.invProfitMoney = _inoutOrderProduct.invProfit * price
      _inoutOrderProduct.invLossMoney = _inoutOrderProduct.invLoss * price
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.form-item {
  margin-bottom: 18px;
}

.form-label {
  margin-right: 10px;
}

.text-left {
  text-align: left;
}
</style>